import { type ComponentType, lazy } from "react"
import type { PopupContentType } from "./types"

type PopupType = PopupContentType["type"]

type LazyImport = () => Promise<{ default: ComponentType }>

const renderers = new Map<PopupType, ComponentType>()
const loaders = new Map<PopupType, LazyImport>()

export function registerLazyPopupRenderer(
	type: PopupType,
	loader: LazyImport,
): void {
	renderers.set(type, lazy(loader))
	loaders.set(type, loader)
}

export function getPopupRenderer(type: PopupType): ComponentType | undefined {
	return renderers.get(type)
}

export function preloadPopupRenderer(type: PopupType): void {
	loaders
		.get(type)?.()
		.catch(() => {})
}
